<header class="app-header">
  <div class="header-wrapper">
    <div class="header-container">
      <div class="header-left">
        <a routerLink="/home" class="brand">
          <span class="brand-name">Markado</span>
        </a>
      </div>

      <div class="header-center">
        <div class="search-wrapper">
          <div class="search-container">
            <input
              type="search"
              placeholder="Search..."
              class="search-input"
              #searchInput
              enterkeyhint="search"
              autocomplete="off"
              (keydown)="onSearchKeydown($event, searchInput.value)"
              inputmode="search"
            />
            <div class="search-actions">
              <button
                type="button"
                class="btn-search"
                (click)="performSearch(searchInput.value)"
                title="Search"
              >
                <svg viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.35-4.35" />
                </svg>
              </button>
              <div class="divider" *ngIf="isLoggedIn"></div>
              <button
                type="button"
                class="btn-ai-search"
                *ngIf="isLoggedIn"
                [class.disabled]="!reverseImageSearchAvailable"
                (click)="openReverseImageSearchModal()"
                [title]="getImageSearchTooltip()"
              >
                <svg viewBox="0 0 24 24">
                  <path
                    d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"
                  />
                  <circle cx="12" cy="13" r="4" />
                </svg>
              </button>
            </div>
          </div>

          <div class="tooltip-error" *ngIf="isServiceUnavailableTooltipVisible">
            {{ getServiceUnavailableMessage() }}
          </div>
        </div>
      </div>

      <div class="header-right">
        <nav class="nav-primary" [class.mobile-active]="isMenuOpen">
          <ul class="nav-menu">
            <li class="nav-item">
              <a
                routerLink="/home"
                routerLinkActive="active"
                class="nav-item-link"
              >
                Home
              </a>
            </li>

            <li
              class="nav-item has-dropdown"
              [class.dropdown-open]="isCategoryDropdownOpen"
            >
              <button class="nav-item-link" (click)="toggleCategoryDropdown()">
                Categories
                <svg class="icon-chevron" viewBox="0 0 24 24">
                  <path d="m6 9 6 6 6-6" />
                </svg>
              </button>
              <div class="dropdown-panel">
                <div class="dropdown-content">
                  <a routerLink="/search/vehicles" class="dropdown-link">
                    <img
                      src="assets/images/categoriesIcon/vehicles.png"
                      alt="Vehicles"
                      class="category-icon-img"
                    />
                    Vehicles
                  </a>
                  <a routerLink="/search/real-estate" class="dropdown-link">
                    <img
                      src="assets/images/categoriesIcon/realEstate.png"
                      alt="Real Estate"
                      class="category-icon-img"
                    />
                    Real Estate
                  </a>
                  <a routerLink="/search/marketplace" class="dropdown-link">
                    <img
                      src="assets/images/categoriesIcon/marketplace.png"
                      alt="Marketplace"
                      class="category-icon-img"
                    />
                    Marketplace
                  </a>
                  <a routerLink="/search/jobs" class="dropdown-link">
                    <img
                      src="assets/images/categoriesIcon/jobs.png"
                      alt="Jobs"
                      class="category-icon-img"
                    />
                    Jobs
                  </a>
                  <div class="dropdown-divider"></div>
                  <a
                    routerLink="/search"
                    class="dropdown-link dropdown-link-primary"
                  >
                    View All Categories
                  </a>
                </div>
              </div>
            </li>

            <li class="nav-item">
              <a
                routerLink="/featured"
                routerLinkActive="active"
                class="nav-item-link"
              >
                Featured
              </a>
            </li>

            <li class="nav-item">
              <a
                routerLink="/recent"
                routerLinkActive="active"
                class="nav-item-link"
              >
                Recent
              </a>
            </li>

            <li class="nav-divider" *ngIf="isLoggedIn"></li>

            <li class="nav-item" *ngIf="isLoggedIn">
              <a
                routerLink="/swipe"
                routerLinkActive="active"
                class="nav-item-link"
              >
                Swipe
              </a>
            </li>

            <li class="nav-item" *ngIf="isLoggedIn">
              <a
                routerLink="/sell"
                routerLinkActive="active"
                class="nav-item-link"
              >
                Sell
              </a>
            </li>

            <li class="nav-item" *ngIf="isLoggedIn">
              <a
                (click)="navigateToWishlist()"
                class="nav-item-link"
                role="button"
              >
                Wishlist
              </a>
            </li>

            <li class="nav-item" *ngIf="!isLoggedIn">
              <a
                routerLink="/login"
                routerLinkActive="active"
                class="nav-item-link nav-link-login"
              >
                Sign In
              </a>
            </li>
          </ul>
        </nav>

        <div class="header-actions">
          <div class="action-profile" *ngIf="isLoggedIn && user">
            <button
              type="button"
              class="btn-profile"
              (click)="toggleProfileMenu()"
            >
              <img
                src="/assets/images/avatar-placeholder/avatar-placeholder.png"
                alt="Profile"
                class="profile-image"
              />
              <span class="badge-dot" *ngIf="hasUnreadMessages()"></span>
            </button>

            <div class="profile-dropdown" *ngIf="isProfileMenuOpen">
              <div class="profile-header">
                <img
                  src="/assets/images/avatar-placeholder/avatar-placeholder.png"
                  alt="Profile"
                  class="profile-avatar"
                />
                <div class="profile-info">
                  <div class="profile-name">
                    {{ user.first_name }} {{ user.last_name }}
                  </div>
                  <div class="profile-email">{{ user.email }}</div>
                </div>
              </div>

              <div class="profile-menu">
                <a routerLink="/profile" class="profile-menu-item">
                  <svg class="menu-icon" viewBox="0 0 24 24">
                    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                    <circle cx="12" cy="7" r="4" />
                  </svg>
                  <span>My Profile</span>
                </a>

                <a routerLink="/my-listings" class="profile-menu-item">
                  <svg class="menu-icon" viewBox="0 0 24 24">
                    <rect x="3" y="3" width="7" height="7" />
                    <rect x="14" y="3" width="7" height="7" />
                    <rect x="14" y="14" width="7" height="7" />
                    <rect x="3" y="14" width="7" height="7" />
                  </svg>
                  <span>My Listings</span>
                </a>

                <a
                  routerLink="/messages"
                  class="profile-menu-item"
                  [class.has-badge]="hasUnreadMessages()"
                >
                  <svg class="menu-icon" viewBox="0 0 24 24">
                    <path
                      d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                    />
                  </svg>
                  <span>Messages</span>
                  <span class="badge-count" *ngIf="hasUnreadMessages()">{{
                    getUnreadBadge()
                  }}</span>
                </a>

                <div class="profile-divider"></div>

                <button
                  class="profile-menu-item profile-menu-logout"
                  (click)="logout()"
                >
                  <svg class="menu-icon" viewBox="0 0 24 24">
                    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
                    <polyline points="16 17 21 12 16 7" />
                    <line x1="21" y1="12" x2="9" y2="12" />
                  </svg>
                  <span>Sign Out</span>
                </button>
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn-menu-toggle"
            (click)="toggleMenu()"
            aria-label="Menu"
          >
            <span class="menu-bar"></span>
            <span class="menu-bar"></span>
            <span class="menu-bar"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</header>

<app-reverse-image-search-modal
  *ngIf="isReverseImageSearchModalOpen"
  (close)="closeReverseImageSearchModal()"
></app-reverse-image-search-modal>
